module.exports = __webpack_public_path__ + "img/nav-video.73fdcdf4.png";